// src/services/authService.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

class AuthService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
    });

    // Request interceptor to add token
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Response interceptor to handle errors
    this.api.interceptors.response.use(
      (response) => response.data,
      (error) => {
        console.error('API Error:', error);
        
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
        
        // Create a proper error object with message
        let errorToReject;
        
        if (error.response?.data) {
          // Use backend error response
          errorToReject = error.response.data;
        } else if (error.message) {
          // Use axios error message
          errorToReject = { message: error.message };
        } else if (typeof error === 'string') {
          // String error
          errorToReject = { message: error };
        } else {
          // Fallback for unknown error types
          errorToReject = { 
            message: 'An unknown error occurred',
            originalError: error.toString()
          };
        }
        
        return Promise.reject(errorToReject);
      }
    );
  }

  async googleLogin(accessToken) {
    // Send access_token to match backend expectation
    const response = await this.api.post('/auth/google-login', { 
      access_token: accessToken 
    });
    return response;
  }

  async logout() {
    await this.api.post('/auth/logout');
  }

  async getCurrentUser() {
    const response = await this.api.get('/auth/me');
    return response.data;
  }

  async refreshToken() {
    const response = await this.api.post('/auth/token/refresh');
    return response.data;
  }
}

// Export an instance of AuthService
export const authService = new AuthService();